import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';

export default function NotFoundPage() {
  return <main className="min-h-screen bg-gray-50 px-6 py-16" data-testid="page-not-found">
    <div className="mx-auto max-w-2xl space-y-5">
      <p className="text-sm font-semibold text-gray-500" data-testid="page-not-found-status">404</p>
      <h1 className="text-4xl font-bold text-gray-900" data-testid="page-not-found-title">Page not found</h1>
      <p className="text-sm text-gray-600" data-testid="page-not-found-message">This page is not available.</p>
      <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-blue-700 hover:text-blue-900 transition-colors" data-testid="page-not-found-home"><ArrowLeft size={16} />Back to dashboard</Link>
    </div>
  </main>;
}
